import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { baseService } from './base.service'
import { IBaseService } from './interfaces/base-service.interface'

import { QueryParams } from '@/types/base.type'
import { ListResponse } from '@/types/list.type'
import { UserNotificationType } from '@/types/notification.type'

export class NotificationService {
  private static instance: NotificationService
  private readonly api: AxiosInstance

  private constructor(private readonly baseService: IBaseService) {
    this.api = this.baseService.getClient()
  }

  public static getInstance(baseService: IBaseService): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService(baseService)
    }
    return NotificationService.instance
  }

  subscribeTopicNotification = async (id: number) => {
    const { data } = await this.api.post(`/notification/topic/${id}/subscribe`)
    return data
  }

  unSubscribeTopicNotification = async (id: number) => {
    const { data } = await this.api.delete(`/notification/topic/${id}/unsubscribe`)
    return data
  }

  getUserNotification = async (queryParams: QueryParams, configs?: AxiosRequestConfig) => {
    const { pageNumber, pageSize } = queryParams
    let url = '/notification/'

    if (pageNumber && pageSize) {
      url += `?pageNumber=${pageNumber}&pageSize=${pageSize}`
    }

    const { data } = await this.api.get<ListResponse<UserNotificationType>>(url, configs)
    return data
  }

  getUserNotificationById = async (id: number, configs?: AxiosRequestConfig) => {
    const { data } = await this.api.get<UserNotificationType>(`/notification/${id}`, configs)
    return data
  }

  updateUserNotification = async (id: number) => {
    const { data } = await this.api.put(`/notification/${id}`)
    return data
  }

  readAllNotification = async () => {
    const { data } = await this.api.put(`/notification/read-all`)
    return data
  }
}

const notificationService = NotificationService.getInstance(baseService)

export default notificationService
